import React, { useContext, useEffect } from "react";
import { navigate } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";
import PropTypes from "prop-types";

import { authContext } from "../contexts/authContext";
import { routes } from "../data/routes";
import LoaderPage from "./LoaderPage";
import { isLoginPath, withLanguagePrefix } from "../utils/localePath";

const PrivateRoute = ({ component: Component, location, ...rest }) => {
	const auth = useContext(authContext);
	const { language } = useI18next();
	const pathname = (location && location.pathname) || "";
	const shouldRedirect =
		!auth.isLoading && !auth.isLoggedIn && !isLoginPath(pathname);

	useEffect(() => {
		if (shouldRedirect) {
			navigate(withLanguagePrefix(routes.login, language));
		}
	}, [shouldRedirect, language]);

	if (auth.isLoading || shouldRedirect) {
		return <LoaderPage />;
	}

	return <Component {...rest} location={location} />;
};

PrivateRoute.propTypes = {
	component: PropTypes.any.isRequired,
};

export default PrivateRoute;
